import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createVNode as _createVNode, Teleport as _Teleport, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "common-map__left-bar-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "common-map__left-bar"
}
const _hoisted_3 = { class: "common-map__left-bar__header heading-m" }
const _hoisted_4 = {
  key: 0,
  class: "common-map__left-bar__items"
}
const _hoisted_5 = {
  key: 1,
  class: "common-map__left-bar__no-data control-m"
}
const _hoisted_6 = { class: "common-map__map" }
const _hoisted_7 = { class: "common-map__bar" }
const _hoisted_8 = {
  key: 0,
  class: "map__button-wrapper"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_10 = { class: "map__button-wrapper" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "map__button-wrapper"
}
const _hoisted_13 = {
  key: 2,
  class: "map__button-wrapper"
}
const _hoisted_14 = {
  key: 'tracks',
  class: "map__button-wrapper"
}
const _hoisted_15 = { class: "map__button-wrapper common-map__search" }
const _hoisted_16 = { class: "map__button-wrapper" }
const _hoisted_17 = {
  key: 0,
  class: "common-map--loading"
}
const _hoisted_18 = {
  key: 1,
  class: "map__overload-warning"
}
const _hoisted_19 = {
  class: /*#__PURE__*/_normalizeClass(['popup-grid'])
}
const _hoisted_20 = { class: "popup-grid__header" }
const _hoisted_21 = {
  class: "popup-grid__content",
  ref: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_MapProviderSelect = _resolveComponent("MapProviderSelect")!
  const _component_MapAreaSelect = _resolveComponent("MapAreaSelect")!
  const _component_NHint = _resolveComponent("NHint")!
  const _component_MapSearch = _resolveComponent("MapSearch")!
  const _component_MapZones = _resolveComponent("MapZones")!
  const _component_NLoadingCircle = _resolveComponent("NLoadingCircle")!
  const _component_LPolyline = _resolveComponent("LPolyline")!
  const _component_Map = _resolveComponent("Map")!
  const _component_NTooltip = _resolveComponent("NTooltip")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.mapEnabled)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['common-map', { 'common-map_has-left-bar': _ctx.showLeftPanel }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.showLeftPanel)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(_ctx.config.sidebarTitle_i18n, 'f')), 1),
                  (_ctx.panelSourceLabel)
                    ? (_openBlock(), _createBlock(_component_NButton, {
                        key: 0,
                        "suffix-icon": "close",
                        type: "secondary",
                        label: _ctx.panelSourceLabel,
                        outline: "",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        onAction: _ctx.reset
                      }, null, 8, ["label", "onAction"]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.panelItems.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.panelItems, (item) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.ListItemComponent), _mergeProps({
                          key: item.id
                        }, _ctx.getListItemProps(item), {
                          selected: _ctx.selectedItems.includes(item.id)
                        }), null, 16, ["selected"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('common.no_data', 'f')), 1))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isSearchMode && _ctx.listItems.length)
          ? (_openBlock(), _createBlock(_Teleport, {
              key: 0,
              to: "#searchLeftSidebar"
            }, [
              _createElementVNode("div", null, [
                _createVNode(_component_NTable, {
                  class: "common-map__table",
                  columns: _ctx.columns,
                  content: _ctx.listItems
                }, null, 8, ["columns", "content"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (!_ctx.isEasyModes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_NButton, {
                    icon: _ctx.showLeftPanel ? 'arrow-left' : 'left-panel',
                    type: "secondary",
                    onAction: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLeftPanel = !_ctx.showLeftPanel))
                  }, null, 8, ["icon"])
                ]))
              : _createCommentVNode("", true),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_MapProviderSelect, {
                modelValue: _ctx.providerId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.providerId) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_11,
            (!_ctx.isEasyModes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (_ctx.map)
                    ? (_openBlock(), _createBlock(_component_MapAreaSelect, {
                        key: 0,
                        map: _ctx.map,
                        "area-draw-on": _ctx.areaDrawOn,
                        "onUpdate:area-draw-on": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.areaDrawOn) = $event)),
                        actions: _ctx.areaActions,
                        onAction: _ctx.handleAreaAction
                      }, null, 8, ["map", "area-draw-on", "actions", "onAction"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.showHasCones)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_NButton, {
                    icon: "camera-track",
                    type: _ctx.hasCones ? 'primary' : 'secondary',
                    onAction: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hasCones = !_ctx.hasCones))
                  }, null, 8, ["type"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.showTracks)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_NHint, {
                    content: _ctx.$t('events.map_tracks_button_description')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NButton, {
                        icon: "tracks",
                        type: _ctx.displayTracks ? 'primary' : 'secondary',
                        onAction: _cache[5] || (_cache[5] = ($event: any) => (_ctx.displayTracks = !_ctx.displayTracks))
                      }, null, 8, ["type"])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_MapSearch, { onSelect: _ctx.handleSearchSelect }, null, 8, ["onSelect"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_MapZones, {
                modelValue: _ctx.currentMapView,
                "onUpdate:modelValue": _ctx.handleViewChanged
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ])
          ]),
          (this.config.module.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_NLoadingCircle)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOverloaded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", null, _toDisplayString(_ctx.overloadThreshold) + "+", 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Map, {
            "locate-on": "",
            "store-state": "",
            "provider-id": _ctx.providerId,
            onMapReady: _ctx.handleMapReady,
            onClick: _ctx.handleMapClick
          }, {
            default: _withCtx(() => [
              (_ctx.displayTracks && _ctx.config.showTracks)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.trackLines, (track) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(track.line, (coords, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          (track.line[index + 1])
                            ? (_openBlock(), _createBlock(_component_LPolyline, {
                                weight: 3,
                                key: index,
                                "lat-lngs": [coords, track.line[index + 1]],
                                color: _ctx.getTrackSegmentColor(track.color, index, track.line.length)
                              }, null, 8, ["lat-lngs", "color"]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 256))
                    ], 64))
                  }), 256))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTracks && _ctx.config.showTracks ? _ctx.computedItems : _ctx.clusterItems, (item, key) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: item.id
                }, [
                  (item.is_cluster)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.config.ClusterMarker), {
                        key: 0,
                        "lat-lng": item.payload.latLng,
                        item: item.payload,
                        color: _ctx.getClusterColor(item.payload),
                        radius: _ctx.getClusterRadius(item.payload),
                        label: item.payload.point_count_abbreviated,
                        onSelect: (event) => _ctx.handleClusterClick(event, item, key)
                      }, null, 8, ["lat-lng", "item", "color", "radius", "label", "onSelect"]))
                    : (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.config.ItemMarker), {
                        key: 1,
                        item: item.payload,
                        colorsConfig: _ctx.config.colorsConfig,
                        "has-cone": _ctx.hasCones,
                        selected: _ctx.selectedItems.includes(item.payload.id),
                        "lat-lng": { lat: item.payload.latitude, lng: item.payload.longitude },
                        opened: _ctx.getIsItemOpened(item.payload),
                        onSelect: () => _ctx.handleClick(item.payload)
                      }, null, 8, ["item", "colorsConfig", "has-cone", "selected", "lat-lng", "opened", "onSelect"]))
                ], 64))
              }), 128))
            ]),
            _: 1
          }, 8, ["provider-id", "onMapReady", "onClick"])
        ]),
        (_ctx.popupState.visible)
          ? (_openBlock(), _createBlock(_component_NTooltip, {
              key: 1,
              "auto-placement": "",
              mode: "manual",
              placement: "right",
              "has-view": false,
              "visible-arrow": false,
              reference: _ctx.popupState.reference,
              to: _ctx.popupState.container
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  onWheel: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_NButton, {
                        type: "text",
                        counter: _ctx.popupState.items.length,
                        onAction: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openAll(_ctx.popupState.items)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('ds.open_all')), 1)
                        ]),
                        _: 1
                      }, 8, ["counter"])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popupState.items, (item) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.config.PopupItem), _mergeProps(_ctx.getItemProps(item), {
                          key: item.id,
                          item: item,
                          onClick: ($event: any) => (_ctx.handleClick(item)),
                          onSelect: ($event: any) => (_ctx.handleClick(item))
                        }), null, 16, ["item", "onClick", "onSelect"]))
                      }), 128))
                    ], 512)
                  ])
                ], 32)), [
                  [_directive_click_outside, _ctx.reset]
                ])
              ]),
              _: 1
            }, 8, ["reference", "to"]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}